module.exports = __webpack_public_path__ + "static/img/zltj3.ca4cdc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/image/zltj3.png
// module id = 47QF
// module chunks = 1